import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import * as _ from "lodash";
import { Customer } from "../../models/customer.model";

import { CustomerService } from "../../services/customer.service";

@Component({
  selector: "ngx-dialog-link-customer",
  templateUrl: "dialog-link-customer.component.html",
  styleUrls: ["dialog-link-customer.component.scss"],
})
export class DialogLinkCustomerComponent implements OnInit {
  @Input() header: string;
  @Input() shopId?: string;
  @Input() linkCustomerId: string;
  @Input() customers?: Customer[];

  diaForm: FormGroup;
  loading = false;
  submitted = false;
  strSearch = "";
  mobile = "";
  page: number = 1;
  display?: Customer[] = [];

  constructor(
    protected ref: NbDialogRef<DialogLinkCustomerComponent>,
    private fb: FormBuilder,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });

    this.onSearch();
  }

  cancel() {
    this.ref.close();
  }

  //Create
  create() {
    let cus = new Customer();
    cus.shopId = this.shopId;
    cus.fullName = this.strSearch.trim();
    cus.mobile = this.mobile.trim();

    if (cus.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.customerService
        .create(cus)
        .then((data) => {
          this.selected(JSON.parse(JSON.stringify(data)));
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      id: "",
    };
    this.ref.close(value);
  }

  pageChange(page: number) {
    this.page = page;
  }

  onSearch(): void {
    this.page = 1;

    const strFilter = this.strSearch.toLowerCase();

    this.loading = true;
    if (!strFilter || strFilter === "") {
      this.display = [...this.customers];
      this.loading = false;
    } else {
      this.display = _.filter(this.customers, function (item) {
        const title = item.fullName ? item.fullName.toLowerCase() : "";
        const mobile = item.mobile ? item.mobile.toLowerCase() : "";
        const address = item.address ? item.address.toLowerCase() : "";

        return (
          (title && title.includes(strFilter)) ||
          (address && address.includes(strFilter)) ||
          (mobile && mobile.includes(strFilter))
        );
      });
    }
    this.loading = false;
  }
}
